<template>
  <router-view v-if="!loading"></router-view>
</template>

<script>
import {CacheService} from "./service/common";
import {TokenService} from "@/service/token";
import router from "@/router";
import {getUrlString, replaceUrl} from "./utils/util";
import {Message} from "element-ui";
import request from "@/plugins/axios";

export default {
  name: "app",
  data() {
    return {
      loading: true // 先获取token再渲染首页，解决首页接口401
    };
  },
  created() {
    const state = CacheService.get("state");
    if (state) {
      this.$store.replaceState(state);
    }

    window.addEventListener("beforeunload", () => {
      CacheService.set("state", this.$store.state);
    });

    let script = document.createElement('script')
    script.type = "text/javascript"
    script.src = `${this.$cloudUrl}/whiteDomain.js`
    document.getElementsByTagName('body')[0].appendChild(script);
    script.onload = () => {
      // eslint-disable-next-line no-undef
      Init(this);
    }
  },
  mounted() {
    const token = TokenService.get()
    const secret = getUrlString("secret");
    if (!token) {
      if (secret) {
        this.axios.get(`/Yunos/User/SSOLogin?secret=${secret}&loginDeviceEnum=102`).then((res) => {
          if (res.code == 401) {
            this.$message.error(res.message)
            setTimeout(() => {
              top.location = `${this.$ssoUrl}/Acount/Logout?returnUrl=${this.$localUrl}`;
            }, 1000)
            return;
          }
          const {
            refreshToken,
            accessToken,
            refreshTokenExpired,
            code,
            message,
          } = res;
          if (code === 200) {
            let obj = {
              refreshToken,
              accessToken,
              refreshTokenExpired,
            };
            localStorage.setItem('tempUserId', res.userId);
            this.axios.defaults.headers.common.Authorization = `Bearer ${res.accessToken}`;
            CacheService.set("account", {
              phone: res.phone,
            });
            TokenService.set(obj);
            let url = window.location.href;
            history.replaceState("", "", url.replace(replaceUrl("secret"), ""));
            this.loading = false;
            router.push('/login');
          } else {
            this.$message.error(message);
          }
        }, (err) => {
          this.axios.get(`/Yunos/User/ApplySecret?applyIdDto=10000002`).then((res) => {
            top.location = `${this.$ssoUrl}/Acount/Authlogin?clientId=10000002&clientSecret=${res.applySecret}&redirect=${this.$localUrl}/&timespan=${res.timeStamp}`
          });
        });
      } else {
        this.axios.get(`/Yunos/User/ApplySecret?applyIdDto=10000002`).then((res) => {
          top.location = `${this.$ssoUrl}/Acount/Authlogin?clientId=10000002&clientSecret=${res.applySecret}&redirect=${this.$localUrl}/&timespan=${res.timeStamp}`
        });
      }
    } else {
      if(!this.$store.state.comp.compId){
        this.$router.push("/login")
        /*this.axios.get(`/Yunos/User/ApplySecret?applyIdDto=10000002`).then((res) => {
          top.location = `${this.$ssoUrl}/Acount/Authlogin?clientId=10000002&clientSecret=${res.applySecret}&redirect=${this.$localUrl}/&timespan=${res.timeStamp}`
        });*/
      }
      this.loading = false
    }
  }
};
</script>

<style>
/* @import "assets/iconfont/iconfont.css"; */
</style>
